
import React from 'react';
import { TableCaption } from '@/components/ui/table';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TransportationCaptionProps {
  onAddTransportation?: () => void;
}

export const TransportationCaption: React.FC<TransportationCaptionProps> = ({ 
  onAddTransportation 
}) => {
  return (
    <TableCaption className="relative">
      <div className="flex justify-between items-center">
        <span>Trip transportation schedule for all travelers</span>
        {onAddTransportation && (
          <Button 
            size="sm" 
            onClick={onAddTransportation} 
            className="absolute right-4 bottom-4 bg-glowingTeal hover:bg-navteal text-white"
          >
            <Plus className="h-4 w-4 mr-1" /> Add
          </Button>
        )}
      </div>
    </TableCaption>
  );
};
